import LoginForm from './lib/form';
import * as S from './styles';
import AppLoading from 'components/appLoading';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

export default function LoginPage() {
  // -- //
  const { login }: any = useTypedSelector((state) => state.Authenticate);

  return (
    <S.AuthContainer>
      <S.FormLogin>
        <S.FormTitle>Sign in</S.FormTitle>
        <S.SubTitle>Enter your email and password to log in.</S.SubTitle>
        <LoginForm />
      </S.FormLogin>

      <AppLoading loading={login.loading} />
    </S.AuthContainer>
  );
}
